function ScopeComponent(Component) {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute(`data-v-${"5c3de0a"}`, "");
  });
}
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-DvT_N_X8.mjs.map
